import React from 'react'
import styled from 'styled-components'

import { BaseItem } from './BaseItem'
import { RedirectDropdownMenuItem } from './types'

interface Props {
  item: RedirectDropdownMenuItem
  leaveSpaceForSubmenu: boolean
}

export const ItemRedirect: React.FC<Props> = ({ item, leaveSpaceForSubmenu }) => {
  return (
    <ItemRedirectWrapper
      onClick={() => {
        window.location.href = item.redirectTo
      }}
    >
      <BaseItem item={item} leaveSpaceForSubmenu={leaveSpaceForSubmenu} />
    </ItemRedirectWrapper>
  )
}

const ItemRedirectWrapper = styled.div``
